module.exports = "https://deal-img.imgix.net/consumer/modern/default-image.0ba33812.jpg";